"use client";

import type { UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import type { PublicationModel } from "../types/models";
import type { DemoShort } from "../utils/demoMode";
import type { SocialProviderAccount } from "./useSocialProviderAccounts";

// Kept apart from the provider (useDemoMode.tsx) so the data hooks that read
// it don't import the hooks the provider is built from.

export type DemoModeData = {
  /** The accounts demo posts go to, once the real ones have loaded. */
  accounts: SocialProviderAccount[] | undefined;
  shorts: DemoShort[] | undefined;
  publications: UseQueryResult<PublicationModel[], Error>;
};

export const DemoModeContext = createContext<DemoModeData | null>(null);

/**
 * The demo data while demo mode is on and the caller is inside a
 * `DemoModeScope` (the calendar and analytics pages); null otherwise.
 */
export const useDemoMode = () => useContext(DemoModeContext);
